import { render, staticRenderFns } from "./InquiryView.vue?vue&type=template&id=24fb71a9"
import script from "./InquiryView.vue?vue&type=script&lang=js"
export * from "./InquiryView.vue?vue&type=script&lang=js"
import style0 from "./InquiryView.vue?vue&type=style&index=0&id=24fb71a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports